import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ExhibitionContainer, PageTitle } from '../styles/exhibitionStyles';

const AboutFeatureImage = styled.img`
  width: 100%;
  max-width: 700px;
  height: auto;
  display: block;
  margin: 0 auto 2rem;
`;

const AboutText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const AboutSection = styled.div`
  margin-bottom: 30px;
`;


const AboutTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 30px;
`;

const TextContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
`;

const ContactSection = styled.div`
  padding: 20px 0;
  margin: 40px 0;
  text-align: center;
`;

const ContactTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const ContactLink = styled.a`
  font-size: 14px;
  color: #000;
  text-decoration: underline;
`;

const CVLink = styled(Link)`
  font-size: 16px;
  color: #000;
  text-decoration: underline;
`;

export default function About() {
  useEffect(() => {
    document.title = "About - SLEEPR";
  }, []);

  return (
    <ExhibitionContainer>
      <AboutFeatureImage src="/img/studio/Instagram-Photo.jpg" alt="Sleepr Feature" />
      <TextContainer>
        <PageTitle>About</PageTitle>

        <AboutText>
        Sleepr (Liam Key, b. 1988) is an ultracontemporary artist whose work creates playful, intricate environments that bring to life the landscapes of imagination and the subconscious. Over the past few years, he has gained recognition in both established and emerging art markets, with his work collected internationally and exhibited in London, Miami, and New York.
        </AboutText>

        <AboutSection>
          <AboutTitle>Practice</AboutTitle>
          <AboutText>
          For over 20 years, Sleepr has developed a practice rooted in translating vivid inner imagery into bold and intricate forms, creating works that capture the richness of imagination and the subconscious. His art seeks to preserve these fleeting mental landscapes as lasting artifacts, combining technical proficiency and innovation with a sense of wonder and play.
          </AboutText>
        </AboutSection>

        <AboutSection>
          <AboutTitle>Academia</AboutTitle>
          <AboutText>
            Sleepr is a prestigious academic, researcher and lecturer, working for many years in Universities in the arts. His research focused on the 'documentation of objects of the imagination', strengthening the theoretical ideas underpinning his work. His research illuminated how artists are uniquely capable of capturing and interpreting complex visual data that eludes conventional scientific abilities and techniques.
          </AboutText>
        </AboutSection>

        <AboutSection>
          <AboutTitle>Exhibitions</AboutTitle>
          <AboutText>
            In March 2023, Sleepr's work The Trinket Maker sold at Sotheby's in the Contemporary Discoveries exhibition, marking a significant milestone in his international recognition. In May 2024, Sleepr debuted his solo exhibition Secrets in Soho, London, where his work received critical acclaim and positive public review.
          </AboutText>
        </AboutSection>

        <AboutSection>
          <AboutTitle>Residencies</AboutTitle>
          <AboutText>
            In December 2023, Sleepr was an artist-in-residence at Art Basel Miami, where he was situated inside of an opaque box as he created work live. The box was a symbol of the priveleged and hidden spaces the artist works in, highlighting the difference between the mundane world and the dream world. To Sleepr, the artist is the navigator of these dream worlds, turning invisible at the point of creation as they enter into hidden spaces, who then return back with prized objects of the imagination few have seen before.
          </AboutText>
        </AboutSection>

        <ContactSection>
          <ContactTitle>Contact</ContactTitle>
          <ContactLink href="mailto:reception@sleeprstudio.com">
            reception@sleeprstudio.com
          </ContactLink>
        </ContactSection>

        <AboutText>
          View the full CV: <CVLink to="/cv">Sleepr CV</CVLink>
        </AboutText>
        
      </TextContainer>
    </ExhibitionContainer>
  );
} 